import SearchParamsBase from '../../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ThirdPartyJobPaymentsAdminSearchParams from './ThirdPartyJobPaymentsAdminSearchParams';

export default class TpEvaluatorPaymentsSearchParams extends SearchParamsBase {
  static saveType = 'TpEvaluatorPaymentsSearchParams';
  initialize() {
    this.TabType = '';
    this.SearchType = '';
    this.TpEvaluatorId = '';
    this.ThirdPartyJobId = '';
    this.ExportId = '';
    this.TypeText = '';
    this.StatusCodeLookupValue = '';
    this.PaymentMethod = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'ThirdPartyJobId', label: 'Third-Party Job ID', className: 'col-2', type: InputTypesEnum.Text },
    { fieldName: 'ExportId', label: 'Export', className: 'col-6', type: InputTypesEnum.Text },
    {
      fieldName: 'TypeText',
      label: 'Type',
      className: 'col-6',
      type: InputTypesEnum.EvaluatorPaymentTypeLookupItemSelect,
      options: ThirdPartyJobPaymentsAdminSearchParams.getTypeTextSelectOptions(),
    },
    {
      fieldName: 'StatusCodeLookupValue',
      label: 'Status',
      className: 'col-6',
      type: InputTypesEnum.LookupMultiChoice,
      options: 45,
      showCondition: (searchItem) => searchItem.TabType !== 'pending_approval',
    },
    {
      fieldName: 'PaymentMethod',
      label: 'Method',
      className: 'col-6',
      type: InputTypesEnum.LookupMultiChoice,
      options: 47,
    },
  ];
}
